import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useBaseRoleTableColumns = (
  editItem,
  apiRef,
  columnPermissions = {},
) => {
  const { canEdit = false } = columnPermissions;

  const columnsData = [
    {
      field: 'name',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 250,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.name;
      },
    },

    ...(canEdit
      ? [
          {
            field: 'actions',
            headerName: 'عملیات',
            type: 'actions',
            flex: 0.5,
            align: 'right',
            minWidth: 240,

            getActions: params => [
              <TableActionButtons
                key={10}
                buttons={
                  params.row.editable
                    ? [
                        {
                          label: 'ویرایش',
                          Icon: ModeEditOutlineIcon,
                          onClick: editItem(params.row),
                          color: 'info',
                        },
                      ]
                    : undefined
                }
              />,
            ],
          },
        ]
      : []),
  ];

  return [columnsData];
};

export default useBaseRoleTableColumns;
